import { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { Row } from "react-bootstrap";

import GenericUtils from "../../../../utils/GenericUtils";
import { axiosGetRequest, axiosPostRequest } from "../../../../api/ApiClient";
import { ArrowRightIcon, CheckIcon } from "../../../../components/Icons";
import { ReactComponent as Close } from "../../../../assets/icons/Close.svg";
import { ReactComponent as InfoIcon } from "../../../../assets/icons/Information.svg";
import { StyledDefaultButtonLink } from "../../../../styles/pages/AcademicActivityPlanStyles";
import UploadFileStyles from "../../../../styles/pages/UploadFilesStyles";
import ButtonStyles from "../../../../styles/components/ButtonStyles";
import ModalDetalhes from "../../../GestaoFaltas/ModalDetalhes";
import DialogMessage from "../../../../components/DialogMessage";
import { useWorkflow } from "../../../../context/WorkflowContext";
import Dialog from "../../../../components/Dialog";
import ModalJustificativa from "../../../GestaoFaltas/ModalJustificativaI";
import ModalJustificativaD from "../../../GestaoFaltas/ModalJustificativaD";
import { IWorflowLegalAllowance } from "../../../../context/interfaces/IWorkflowContext";
import { DialogConfirm } from "../../../GestaoFaltas/Components/DialogConfirm";
import { ActionsWrapper } from "../../../../styles/pages/Workflows/OvertimeActions";
import StatusPill from "../StatusPill/StatusPill";

interface LegalAllowanceActionsProps {
    workflow: IWorflowLegalAllowance;
}

const { StyledImportButton, StyledModalTitle } = UploadFileStyles;
const { DefaultButtonLink } = ButtonStyles;

const INDEFERIR = "I";
const DEFERIR = "D";
const AGUARDANDO_APROVACAO = "A";

const LegalAllowanceActions: React.FC<LegalAllowanceActionsProps> = ({
    workflow,
}) => {
    const [activeModal, setActiveModal] = useState<boolean>(false);
    const [showRejectAllowanceModal, setShowRejectAllowanceModal] =
        useState<boolean>(false);
    const [showDeferredAllowanceModal, setShowDeferredAllowanceModal] =
        useState<boolean>(false);
    const [modalEdit, setModalEdit] = useState<boolean>(false);
    const [objectFalta, setObjectFalta] = useState<any>({});
    const [objectSolicitacao, setObjectSolicitacao] = useState<any>({});
    const [modalIndeferir, setModalIndeferir] = useState<boolean>(false);
    const [modalDeferir, setModalDeferir] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>("");

    const [inEdit, setInEdit] = useState(false);

    const { instance } = useMsal();

    const { workflowFilter, filterWorkflows } = useWorkflow();

    const handleCloseDialogError = () => {
        setErrorMessage("");
    };

    const handleCloseRejectAllowanceModal = () => {
        setShowRejectAllowanceModal(false);
        filterWorkflows(workflowFilter);
    };

    const handleCloseDeferredAllowanceModal = () => {
        setShowDeferredAllowanceModal(false);
        filterWorkflows(workflowFilter);
    };

    const handleView = async (abonoId: number, inEdite: boolean) => {
        setInEdit(inEdite);
        const response = await axiosGetRequest(
            `docente/v1/workflows/justificativa-checkin/${abonoId}/abono-legal`,
            GenericUtils.getAccessTokenDocente(),
            instance
        );
        if (response.status >= 200 && response.status < 300) {
            setObjectFalta(response.data.dadosWorkflow);
            setObjectSolicitacao(response.data.solicitacaoAbonoLegal);
            setModalEdit(true);
        } else {
            setErrorMessage(response.data?.details);
        }
    };

    const handleSubmit = async (
        justificativa: string,
        // eslint-disable-next-line @typescript-eslint/no-shadow
        status: string,
        solicitacaoAbonoLegal: any
    ) => {
        const response = await axiosPostRequest(
            `docente/v1/workflows/justificativa-checkin/${objectFalta.workflowExecucaoId}/abono-legal`,
            {
                workflowExecucaoId: objectFalta.workflowExecucaoId,
                solicitacaoAbonoLegal,
                justificativa,
                status,
            },
            GenericUtils.getAccessTokenDocente(),
            instance
        );

        if (response.status >= 200 && response.status < 300) {
            if (status === INDEFERIR) {
                setModalIndeferir(false);
                setShowRejectAllowanceModal(true);
            } else {
                setShowDeferredAllowanceModal(true);
            }
        } else {
            setErrorMessage(response.data?.details);
        }
    };

    const handleIndeferir = async (justificativa: string) => {
        const resp = await axiosGetRequest(
            `docente/v1/workflows/justificativa-checkin/${objectFalta.workflowExecucaoId}/abono-legal`,
            GenericUtils.getAccessTokenDocente(),
            instance
        );
        await handleSubmit(
            justificativa,
            INDEFERIR,
            resp.data.solicitacaoAbonoLegal
        );
    };

    const handleDeferir = async (justificativa: string) => {
        await handleSubmit(justificativa, DEFERIR, objectFalta);
    };

    const handleClose = () => {
        setActiveModal(false);
        setModalEdit(false);
        setShowRejectAllowanceModal(false);
        setShowDeferredAllowanceModal(false);
        setModalIndeferir(false);
        setModalDeferir(false);
    };

    const dialogIndeferir = modalIndeferir && (
        <ModalJustificativa
            open={modalIndeferir}
            onSave={(justificativa: string) => {
                handleIndeferir(justificativa);
            }}
            onClose={() => {
                handleClose();
            }}
        />
    );

    const dialogDeferir = modalDeferir && (
        <ModalJustificativaD
            open={modalDeferir}
            onSave={(justificativa: string) => {
                setModalDeferir(false);
                handleDeferir(justificativa);
            }}
            onClose={() => {
                handleClose();
            }}
        />
    );

    const DialogActiveConfirm = activeModal && (
        <Dialog openModal={activeModal} onHide={handleClose}>
            <StyledModalTitle>Deferir abono legal</StyledModalTitle>

            <Row style={{ justifyContent: "center" }}>
                <StyledImportButton
                    style={{ width: 126, marginTop: 24 }}
                    onClick={() => {
                        handleDeferir("");
                    }}
                >
                    Deferir
                </StyledImportButton>
            </Row>
            <div style={{ height: 15 }} />
            <Row style={{ justifyContent: "center" }}>
                <DefaultButtonLink
                    onClick={() => {
                        handleClose();
                    }}
                >
                    Cancelar
                </DefaultButtonLink>
            </Row>
        </Dialog>
    );

    const DialogError = Boolean(errorMessage) && (
        <DialogMessage
            type="error"
            show={Boolean(errorMessage)}
            title={errorMessage}
            onClose={handleCloseDialogError}
        />
    );

    const hasToBeReadOnly = (status: string) => {
        return status === "I" || status === "D";
    };

    const dialogDetalhes = modalEdit && (
        <ModalDetalhes
            open={modalEdit}
            onDeferir={(e: any) => {
                setObjectFalta(e);
                setModalEdit(false);
                setModalDeferir(true);
            }}
            onIndeferir={() => {
                setModalEdit(false);
                setModalIndeferir(true);
            }}
            solicitacaoI={objectSolicitacao}
            dadosWorkflowI={objectFalta}
            onClose={() => {
                handleClose();
            }}
            docenteIdI={undefined}
            inEdit={inEdit}
            readOnly={hasToBeReadOnly(workflow.status)}
        />
    );

    const rejectAllowanceModal = showRejectAllowanceModal && (
        <DialogConfirm
            openModal={showRejectAllowanceModal}
            handleClose={handleCloseRejectAllowanceModal}
            modalTitle="Abono Indeferido"
            modalText="O professor será avisado que o abono foi indeferido."
            acceptButtonText="Ok"
        />
    );

    const deferredAllowanceModal = showDeferredAllowanceModal && (
        <DialogConfirm
            openModal={showDeferredAllowanceModal}
            handleClose={handleCloseDeferredAllowanceModal}
            modalTitle="Abono Deferido"
            modalText="O professor será avisado que o abono foi deferido. Todas as atividades do período foram abonadas."
            acceptButtonText="Ok"
        />
    );

    const getStatusLabel = (status: string): string => {
        if (status === INDEFERIR) {
            return "Indeferido";
        }

        return "Deferido";
    };

    return (
        <div
            style={{
                display: "flex",
            }}
        >
            {workflow.status === AGUARDANDO_APROVACAO ? (
                <>
                    <StyledDefaultButtonLink
                        variant="link"
                        onClick={() => {
                            handleView(workflow.workflowExecucaoId, false);
                        }}
                    >
                        <ArrowRightIcon style={{ fill: "#8A0538" }} />
                        Ver detalhes
                    </StyledDefaultButtonLink>
                    <StyledDefaultButtonLink
                        variant="link"
                        onClick={() => {
                            setObjectFalta(workflow);
                            setModalIndeferir(true);
                        }}
                    >
                        <Close
                            style={{
                                fill: "#8A0538",
                                fontSize: 20,
                            }}
                        />
                        Indeferir
                    </StyledDefaultButtonLink>
                    <StyledDefaultButtonLink
                        variant="link"
                        onClick={() => {
                            setObjectFalta(workflow);
                            handleView(workflow.workflowExecucaoId, true);
                        }}
                    >
                        <CheckIcon style={{ fill: "#8A0538" }} />
                        Deferir
                    </StyledDefaultButtonLink>
                </>
            ) : (
                <ActionsWrapper>
                    <StatusPill
                        status={getStatusLabel(workflow.status)}
                        key={workflow.workflowExecucaoId}
                    />
                    <StyledDefaultButtonLink
                        variant="link"
                        onClick={() =>
                            handleView(workflow.workflowExecucaoId, false)
                        }
                    >
                        <InfoIcon style={{ fill: "#8A0538" }} />
                        Visualizar Informações
                    </StyledDefaultButtonLink>
                </ActionsWrapper>
            )}

            {DialogError}
            {dialogDetalhes}
            {DialogActiveConfirm}
            {dialogIndeferir}
            {dialogDeferir}
            {rejectAllowanceModal}
            {deferredAllowanceModal}
        </div>
    );
};

export default LegalAllowanceActions;
